var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-tabs"},_vm._l((_vm.tabs),function(tab){return _c('div',{key:tab,staticClass:"base-tabs--tab",class:{ 'base-tabs--tab--selected': tab === _vm.value },on:{"click":function($event){return _vm.$emit('input', tab)}}},[_vm._v(" "+_vm._s(tab)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }